// Special Infiniwell organisation UUID — the superadmin org.
// Keep in sync with admin-server/app/routers/organisations.py:INFINIWELL_ORG_ID
export const INFINIWELL_ORG_ID = '00000000-0000-0000-0000-000000000001';
